import { render, staticRenderFns } from "./ActivateClient.vue?vue&type=template&id=b110869e&"
import script from "./ActivateClient.vue?vue&type=script&lang=js&"
export * from "./ActivateClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports